import React, { useEffect, useState } from 'react';
import { Alert, Box, Button, Card, CardContent, Typography } from '@mui/material';
import { Link, Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';
import { getPublicConfig } from '../services/AuthService';
import { LoadingSpinner } from '../components/LoadingSpinner';

export default function Home() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const { hasPlayerSession, playAsGuest } = useAuth();
    const [config, setConfig] = useState(null);
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState('');
    useEffect(() => { getPublicConfig().then(setConfig).catch(() => setConfig({ isPlayerLoginMandatory: true })); }, []);
    if (hasPlayerSession) return <Navigate to="/games" replace />;
    if (!config) return <LoadingSpinner show />;
    const returnTo = location.state?.returnTo || '/games';
    const guest = async () => { setBusy(true); setError(''); try { await playAsGuest(); navigate(returnTo, { replace: true }); }
        catch (_) { setError(t('auth.errors.guestSessionFailed')); } finally { setBusy(false); } };
    return <Box className="app-page auth-page">
        <LoadingSpinner show={busy} />
        <Card className="app-surface auth-card" sx={{ width: { xs: '90%', sm: 400 } }}><CardContent>
            <Typography component="h1" variant="h4" align="center" sx={{ mb: 3, whiteSpace: 'nowrap' }}>GaSarMal</Typography>
            {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
            <Box sx={{ display: 'grid', gap: 1.5 }}>
                <Button disabled={busy} component={Link} to="/login" state={{ returnTo }} variant="contained">{t('auth.login')}</Button>
                <Button disabled={busy} component={Link} to="/register" state={{ returnTo }} variant="outlined">{t('auth.register')}</Button>
                {!config.isPlayerLoginMandatory && <Button disabled={busy} onClick={guest} variant="outlined">{t('auth.playAsGuest')}</Button>}
            </Box>
        </CardContent></Card>
    </Box>;
}
